import * as S from "components/common/SliderInfo/Slider.style";

const ContentSlider = ({
    icon,
    map,
    alt,
    title,
    description,
    ...props
}) => {
    return (
        <S.ContentCard>
            <S.ContainerImage {...{
                src: map,
                alt: alt,
            }} />
            <S.CardInfo>
                <S.Icon {...{
                    src: icon,
                    alt: alt
                }} />
                <S.CardContainer>
                    <S.CardTitle variant='headline-03'>{title}</S.CardTitle>
                    <S.Description variant='headline-04'>{description}</S.Description>
                </S.CardContainer>
            </S.CardInfo>
            <S.Paragraph>
                Dados baseados no relatório de sustentabilidade de 2021
            </S.Paragraph>
        </S.ContentCard>
    );
};

export default ContentSlider;